import styled, { css } from 'styled-components';
import { ColorScheme, Colors, Fonts } from 'styles/constants';

export {
  ModalHeader,
  ModalContent,
  ModalBody,
  FormRow,
  FormActions,
  Button,
  ActivityIndicator,
} from 'styles/components';

export const TabsContainer = styled.fieldset<{ $disabled: boolean }>`
  min-width: 0;
  margin: 0 0 24px;
  padding: 0;
  border: 0;

  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      opacity: 0.65;
    `}
`;

export const InventoryText = styled.p`
  margin: 8px 0;
  color: ${ColorScheme.LightText};
  font-family: ${Fonts.GilroyRegular};
  font-size: 14px;
`;

export const BatchPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${Colors.Gray10};
  color: ${ColorScheme.Text};
  font-family: ${Fonts.GilroyRegular};

  strong {
    font-family: ${Fonts.GilroySemiBold};
  }
`;

export const ConflictAlert = styled.div`
  margin-top: 16px;
  padding: 12px 16px;
  border: 1px solid ${ColorScheme.Danger};
  border-radius: 8px;
  color: ${ColorScheme.Danger};
  font-family: ${Fonts.GilroySemiBold};
`;
